document.addEventListener("DOMContentLoaded", async () => {
  const container = document.getElementById("recently-viewed");
  if (!container) return;

  const viewport = container.querySelector(".recently-viewed__viewport");
  const track = container.querySelector("#recently-viewed-track");
  const buttonsContainer = container.querySelector(".recently-viewed__buttons");
  const btnPrev = container.querySelector(".rv-btn--prev");
  const btnNext = container.querySelector(".rv-btn--next");
    
  const currentHandle = container.dataset.currentHandle || null;
  const maxItems = parseInt(container.dataset.maxItems, 10) || 10;

  /* -----------------------------
      HELPERS
  ------------------------------ */

  function formatMoney(cents) {
    return Shopify?.formatMoney ? Shopify.formatMoney(cents) : `₪${(cents / 100).toFixed(2)}`;
  }

  function metalColor(name) {
    if (!name) return "#ccc";
    const n = name.toLowerCase();
    if (n.includes("white")) return "#d9d9d9";
    if (n.includes("yellow")) return "#EDC891";
    if (n.includes("rose")) return "#f2b6a0";
    if (n.includes("platinum")) return "#747576";
    return "#ccc";
  }

  function extractMetals(p) {
    const metalOption = p.options?.find(o => o.name.toLowerCase() === "metal");
    if (!metalOption) return [];
    const idx = metalOption.position - 1;
    return [...new Set(p.variants.map(v => v[`option${idx + 1}`]).filter(Boolean))];
  }

  function isMobile() {
    return window.innerWidth <= 768;
  }

  /* -----------------------------
      READ + UPDATE LOCALSTORAGE
  ------------------------------ */

  let storedHandles = [];

  try {
    const raw = localStorage.getItem("recently_viewed");
    storedHandles = raw ? JSON.parse(raw) : [];
    if (!Array.isArray(storedHandles)) storedHandles = [];
  } catch (e) {
    console.warn("[RV] Failed to parse recently_viewed from localStorage:", e);
    storedHandles = [];
  }

  // обновляем список: помещаем текущий товар в начало, убираем дубликаты
  if (currentHandle) {
    storedHandles = storedHandles.filter(h => h !== currentHandle);
    storedHandles.unshift(currentHandle);
  }

  // ограничиваем длину хранилища
  storedHandles = storedHandles.slice(0, maxItems + 5);

  try {
    localStorage.setItem("recently_viewed", JSON.stringify(storedHandles));
  } catch (e) {
    console.warn("[RV] Failed to write recently_viewed to localStorage:", e);
  }

  // хэндлы для показа (без текущего товара)
  let viewed = storedHandles.filter(h => h !== currentHandle).slice(0, maxItems);

  // если показывать нечего — скрываем секцию и выходим
  if (!viewed.length) {
    container.style.display = "none";
    return;
  }

  /* -----------------------------
      LOAD PRODUCTS DATA
  ------------------------------ */

  const CACHE_KEY = "recently_viewed_cache";
  const CACHE_TTL = 24 * 60 * 60 * 1000;
  let cache = {};

  try {
    const rawCache = localStorage.getItem(CACHE_KEY);
    cache = rawCache ? JSON.parse(rawCache) : {};
  } catch (e) {
    console.warn("[RV] Failed to parse cache:", e);
    cache = {};
  }

  async function loadProduct(handle) {
    const now = Date.now();

    if (cache[handle] && now - cache[handle].timestamp < CACHE_TTL) {
      return cache[handle].data;
    }

    try {
      const res = await fetch(`/products/${handle}.js`);
      if (!res.ok) return null;

      const data = await res.json();
      cache[handle] = { data, timestamp: now };

      try {
        localStorage.setItem(CACHE_KEY, JSON.stringify(cache));
      } catch (e) {
        console.warn("[RV] Failed to write cache:", e);
      }

      return data;
    } catch (e) {
      console.warn("[RV] Error loading product", handle, e);
      return null;
    }
  }

  const products = [];
  for (const handle of viewed) {
    const p = await loadProduct(handle);
    if (p) products.push(p);
  }

  if (!products.length) {
    container.style.display = "none";
    return;
  }

  /* -----------------------------
      RENDER CARDS
  ------------------------------ */

  function renderCards(arr) {
    return arr
      .map((p) => {
        const img = p.images?.[0];
        const metals = extractMetals(p);

        return `
          <div class="rv-card">
            <a href="/products/${p.handle}">
              <div class="rv-card__image-wrapper">
                ${img ? `<img src="${img}" alt="${p.title}" class="rv-card__image">` : ""}
              </div>
              <div class="rv-card__info">
                <p class="rv-card__title">${p.title}</p>
                <p class="rv-card__price">${formatMoney(p.price)}</p>
                ${
                  metals.length
                    ? `<div class="rv-card__variants">
                        ${metals
                          .map(
                            (m) =>
                              `<span class="rv-card__variant" style="background:${metalColor(
                                m
                              )};"></span>`
                          )
                          .join("")}
                       </div>`
                    : ""
                }
              </div>
            </a>
          </div>
        `;
      })
      .join("");
  }

  track.innerHTML = renderCards(products);

  /* -----------------------------
      SLIDER LOGIC
  ------------------------------ */

  let currentIndex = 0; // Текущий индекс первой видимой карточки
  const cardsToShow = 3; // Показываем 3 карточки за раз

  function scrollToIndex(index) {
    const cards = track.querySelectorAll('.rv-card');
    if (!cards.length) return;

    // Нормализуем индекс (бесконечный цикл)
    if (index < 0) {
      index = cards.length - cardsToShow;
    } else if (index > cards.length - cardsToShow) {
      index = 0;
    }

    currentIndex = index;
    

    const targetCard = cards[index];
    if (targetCard) {
      targetCard.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'nearest', 
        inline: 'start' 
      });
    }
  }

  function updateButtons() {
    // Кнопки всегда активны для бесконечного цикла
    if (btnPrev) btnPrev.disabled = false;
    if (btnNext) btnNext.disabled = false;
    

  }

  function applyMode() {


    // На мобилке всегда grid
    if (isMobile()) {
      viewport.classList.add("is-grid");
      viewport.classList.remove("is-slider");
      if (buttonsContainer) buttonsContainer.hidden = true;
      return;
    }

    // На десктопе/планшете: >3 товара = слайдер, иначе grid
    if (products.length > 3) {
      viewport.classList.add("is-slider");
      viewport.classList.remove("is-grid");
      if (buttonsContainer) buttonsContainer.hidden = false;

      // Обработчики кнопок
      if (btnPrev) {
        btnPrev.addEventListener('click', (e) => {
          e.preventDefault();

          // Prev = показать следующие 3 карточки (скролл влево в RTL)
          scrollToIndex(currentIndex + cardsToShow);
        });
      }

      if (btnNext) {
        btnNext.addEventListener('click', (e) => {
          e.preventDefault();
          // Next = показать предыдущие 3 карточки (скролл вправо в RTL)
          scrollToIndex(currentIndex - cardsToShow);
        });
      }

      // Инициализация
      updateButtons();
    } else {
      // Grid режим
      viewport.classList.add("is-grid");
      viewport.classList.remove("is-slider");
      if (buttonsContainer) buttonsContainer.hidden = true;
      track.removeEventListener("scroll", updateButtons);
    }
  }

  applyMode();
  
  // При изменении размера окна пересчитываем режим
  let resizeTimeout;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(applyMode, 150);
  });
});
